import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'
import Image from 'next/image'

const resource = createResource({
  en: {
    mainTitle: 'Banks We Cooperate with: BCA, Bank Mandiri, BNI, BRI',
  },
  id: {
    mainTitle: 'Bank Yang Bekerjasama dengan Kami: BCA, Bank Mandiri, BNI, BRI',
  },
})

const Banks = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/home/bca-logo.png',
      bank: 'bca',
    },
    {
      img: '/images/home/bni-logo.png',
      bank: 'bni',
    },
    {
      img: '/images/home/mandiri-logo.png',
      bank: 'mandiri',
    },
    {
      img: '/images/home/bri-logo.png',
      bank: 'bri',
    },
  ]
  return (
    <BankStyle>
      <h2 className="title">{t('mainTitle')}</h2>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <Reveal key={index} delay={200 + index * 150} animation={Animation.FadeIn}>
              <div className="item">
                <div className="img">
                  <LazyLoad>
                    <Image src={item.img} alt={item.bank} width={282} height={140} quality={85} placeholder="empty" />
                  </LazyLoad>
                </div>
              </div>
            </Reveal>
          ))
        ) : (
          <>
            {FeatureList.map((item, index) => (
              <div key={index} className="item">
                <div className="img">
                  <LazyLoad>
                    <Image src={item.img} alt={item.bank} width={168} height={84} quality={85} placeholder="empty" />
                  </LazyLoad>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </BankStyle>
  )
}

export default Banks

const BankStyle = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 40px auto;
    text-align: center;
    width: 360px;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 32px;
    }
    .items {
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      .item {
        width: 46%;
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 72px 140px 0px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      margin-bottom: 48px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        width: 282px;
        text-align: left;
        .img {
          width: 100%;
          height: 140px;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
`
